import { default as _91_46_46_46slug_93VqH5PLh2uuMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/[...slug].vue?macro=true";
import { default as indexdXUnmtrZyYMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/auth/index.vue?macro=true";
import { default as datenschutzHHy3hkoP93Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/datenschutz.vue?macro=true";
import { default as datenverarbeitunggohK6V7aGyMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/datenverarbeitung.vue?macro=true";
import { default as _91id_93n9X2PjPucjMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93GXxMxQElmUMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/formProcess/success/[id].vue?macro=true";
import { default as impressumW8diM5qx4sMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/impressum.vue?macro=true";
import { default as indexszPFmFRfHnMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/index.vue?macro=true";
import { default as _91slug_93xdVkrzrXyiMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/news/[slug].vue?macro=true";
import { default as organisationsn30CPBABhAMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/organisations.vue?macro=true";
import { default as indexSJRRUWwjd6Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/processes/index.vue?macro=true";
import { default as dungeonoLCNCswL3cMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsa4SJkDEyR8Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexv4aX9K3Z3lMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/secret/index.vue?macro=true";
import { default as indexcK85U8dDlPMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseData6GO0MVgQUmMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassefAhGaBGRXMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93kxWk7Mxtw3Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexsgHxhw6uYqMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseData3CM2SR8LP9Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramReports00SyN1odMRMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsurKyZJItxMMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93QClhqMeZ3VMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexOPXQrmxlYkMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesmf8vu19UY7Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatapEGXv0OBkdMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93bS0WvsxnupMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexBMbhDktlPFMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesu0xIRaA9lvMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataby7yWiMBAmMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_933s8k6ELJLPMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexVxMb5L1JQmMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDatavnwBJEMeScMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93BMxUUJh5ueMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexdxqm3KYNKcMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statusActivitiesTjpqv6GRqRMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDatai4J3irE70WMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsMIXCanz8ZqMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93ugDoKSCV2sMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexdGOe9WPtmuMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataJmCq82qs7xMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatalX7sbzFGFMMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as yearInterviewsefco9kdPBIMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id]/yearInterviews.vue?macro=true";
import { default as _91id_93RahmfFzJpHMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexQdOQx3bBI7Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatafw77hNIp6NMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93i06uTt5jy5Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexblcxHSYA4vMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/index.vue?macro=true";
import { default as paymentRunActivitiesXb80Hx8WNtMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue?macro=true";
import { default as paymentRunBaseData8gsr0kMyekMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsLAeo7Xp1oKMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93vlYmVuFVwoMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexAj9eNdO5qeMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as payments8bcgA0xFC7Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments.vue?macro=true";
import { default as processActivities3kGvDOGDs7Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseData1VlNfGQIbkMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_933XQIvxOoizMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/[id].vue?macro=true";
import { default as index9KqpHuu6tiMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalLVfjESyaRFMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/massApproval.vue?macro=true";
import { default as organisationActivitiesBraeLpZyWKMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsAIA5VSkv8DMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataNJ6ckTEsqvMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesHwRgCvDjz6Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptErehBxiPQuMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetz4Lxsf1lgcMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersUluXaoRuwgMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93hjvbrhA10UMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexhTnwWbBlUwMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisations2TqtAZKWgcMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitieseAcc2NYdoQMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatawY9JlcnJGCMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltershQYPmqYx9HMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureDfEedXtCLXMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93Uxylnhi7zZMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexZ5fj6w4stFMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersk3aTI42PK3Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users.vue?macro=true";
import { default as settingstq0pxEPqtYMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings.vue?macro=true";
import { default as servicevRJmanyzT4Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service.vue?macro=true";
import { default as indexdtBrwQPPKvMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/childOrganisations/index.vue?macro=true";
import { default as languageTNfrwQgypnMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDatavGMzGeWXCWMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesehaJ0HCQ7gMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptpMjwVu5KQNMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetj8bAX8gWH4Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersQY80Bb4utxMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93y6VjgX5W40Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatajcBJzc3fJlMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignature36dvrG6pqoMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93AyDpS7ilQDMeta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/users/[id].vue?macro=true";
import { default as settingsB8Myr39Qd1Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings.vue?macro=true";
import { default as signaturetxg7nHRNv8Meta } from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/signature.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93VqH5PLh2uuMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexdXUnmtrZyYMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/auth/index.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/datenschutz.vue")
  },
  {
    name: "datenverarbeitung",
    path: "/datenverarbeitung",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/datenverarbeitung.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93n9X2PjPucjMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93GXxMxQElmUMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexszPFmFRfHnMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsn30CPBABhAMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexSJRRUWwjd6Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/processes/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicevRJmanyzT4Meta?.name,
    path: "/service",
    meta: servicevRJmanyzT4Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatafw77hNIp6NMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexcK85U8dDlPMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93kxWk7Mxtw3Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexsgHxhw6uYqMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93QClhqMeZ3VMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexOPXQrmxlYkMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93bS0WvsxnupMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexBMbhDktlPFMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_933s8k6ELJLPMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexVxMb5L1JQmMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93BMxUUJh5ueMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexdxqm3KYNKcMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93ugDoKSCV2sMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsMIXCanz8ZqMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexdGOe9WPtmuMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93RahmfFzJpHMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id]/yearData.vue")
  },
  {
    name: "service-basicData-years-id-yearInterviews",
    path: "yearInterviews",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/[id]/yearInterviews.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexQdOQx3bBI7Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93i06uTt5jy5Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/index.vue")
  },
  {
    name: "service-payments",
    path: "payments",
    meta: payments8bcgA0xFC7Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93vlYmVuFVwoMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunActivities",
    path: "paymentRunActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexAj9eNdO5qeMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_933XQIvxOoizMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: index9KqpHuu6tiMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalLVfjESyaRFMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingstq0pxEPqtYMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings.vue"),
    children: [
  {
    name: organisations2TqtAZKWgcMeta?.name,
    path: "organisations",
    meta: organisations2TqtAZKWgcMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93hjvbrhA10UMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexhTnwWbBlUwMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersk3aTI42PK3Meta?.name,
    path: "users",
    meta: usersk3aTI42PK3Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93Uxylnhi7zZMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexZ5fj6w4stFMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsB8Myr39Qd1Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings.vue"),
    children: [
  {
    name: "settings-childOrganisations",
    path: "childOrganisations",
    meta: indexdtBrwQPPKvMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/childOrganisations/index.vue")
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93y6VjgX5W40Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93AyDpS7ilQDMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturetxg7nHRNv8Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/pages/signature.vue")
  }
]